import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { IChecklist2ReportHistoryComplianceData } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { IReportChartData } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart';

@Component({
    selector: 'fi-history-chart-non-compliance',
    templateUrl: './history-chart-non-compliance.component.html',
    styleUrl: './history-chart-non-compliance.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-history-non-compliance-chart' },
    standalone: false,
})
export class FiChecklistHistoryComplianceChart {
    @Input() isDetailedData: boolean;
    @Input() cardClass: string = '';

    private _nonComplianceData: IChecklist2ReportHistoryComplianceData;
    @Input({ required: true }) set nonComplianceData(value: IChecklist2ReportHistoryComplianceData) {
        this._nonComplianceData = value;
        this.setChartValues();
    }
    get nonComplianceData(): IChecklist2ReportHistoryComplianceData {
        return this._nonComplianceData;
    }
    reportChartData: IReportChartData[];

    private setChartValues() {
        this.reportChartData = [
            {
                gradientColorLight: '#FF6454',
                gradientColorBright: '#DE3730',
                value: this.nonComplianceData.nonComplianceUnitsCount,
            },
            {
                gradientColorLight: '#29CC6A',
                gradientColorBright: '#18C45D',
                value: this.nonComplianceData.complianceUnitsCount,
            },
        ];
    }

    getValueLabel(value: number): string {
        const percentageValue: string = this.getPercentageValueStr(value);
        return this.isDetailedData
            ? `<span class="bold">${percentageValue}</span> (${value}/${this.nonComplianceData.iterationsCount})`
            : percentageValue;
    }

    getPercentageValue(value: number): number {
        return Math.round((100 * value) / this.nonComplianceData.iterationsCount);
    }
    getPercentageValueStr(value: number): string {
        return `${this.getPercentageValue(value)}%`;
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
